import React, { ReactElement } from 'react';
import { Text } from '@shootsta/common-react';
import { ReactComponent as ShootstaLogo } from '../../../../../../assets/images/shootsta-logo.svg';
import TrackingLink from '../../constants/TrackingLink';

import './styles/_footer.scss';

interface FooterProps {
  contactUser?: {
    firstName: string;
    lastName: string;
    organisationTitle: string;
    email: string;
    phone: string;
  }
}

const Footer = ({ contactUser }: FooterProps): ReactElement => {
  const {
    firstName,
    lastName,
    organisationTitle,
    email,
    phone
  } = contactUser || {};

  return (
    <footer className="footer">
      {contactUser && (
        <>
          <div className="footer__contact">
            <Text label noMargin centered>
              <b>{`${firstName} ${lastName} - ${organisationTitle}`}</b>
            </Text>
            <Text label noMargin centered>{email}</Text>
            <Text label noMargin centered>{phone}</Text>
          </div>
        </>
      )}
      <div className="footer__shootsta">
        <div className="footer__shootsta__inner">
          <Text label noMargin className="footer__shootsta__inner--powered">
            Powered by
          </Text>
          <a href={TrackingLink}>
            <ShootstaLogo className="footer__shootsta__inner--logo" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
